"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TransactionInfoCard", {
  enumerable: true,
  get: function get() {
    return _Card.Card;
  }
});
var _Card = require("./Card");